<template>
    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="4.5" cy="4.5" r="4.5" fill="white" />
        <g clip-path="url(#clip0_0_1PreOrder)">
            <path d="M3.06836 5.64453L2.36523 3.30078H6.88281L6.17969 5.64453H3.06836Z" fill="#AAB6EC" />
            <path
                d="M6.58398 6.34766H3.15695L2.10227 2.83203H1.11719V2.59766H2.27664L3.33133 6.11328H6.58398V6.34766Z"
                fill="#AAB6EC"
            />
            <path d="M6.02734 6.78711H3.80078V7.02148H6.02734V6.78711Z" fill="#AAB6EC" />
            <path
                d="M6.02734 7.46094C6.33477 7.46094 6.58398 7.21172 6.58398 6.9043C6.58398 6.59687 6.33477 6.34766 6.02734 6.34766C5.71992 6.34766 5.4707 6.59687 5.4707 6.9043C5.4707 7.21172 5.71992 7.46094 6.02734 7.46094Z"
                fill="#EDEFF1"
            />
            <path
                d="M6.02734 7.18555C6.18267 7.18555 6.30859 7.05963 6.30859 6.9043C6.30859 6.74897 6.18267 6.62305 6.02734 6.62305C5.87201 6.62305 5.74609 6.74897 5.74609 6.9043C5.74609 7.05963 5.87201 7.18555 6.02734 7.18555Z"
                fill="#AAB6EC"
            />
            <path
                d="M3.80078 7.46094C4.10821 7.46094 4.35742 7.21172 4.35742 6.9043C4.35742 6.59687 4.10821 6.34766 3.80078 6.34766C3.49336 6.34766 3.24414 6.59687 3.24414 6.9043C3.24414 7.21172 3.49336 7.46094 3.80078 7.46094Z"
                fill="#EDEFF1"
            />
            <path
                d="M3.80078 7.18555C3.95611 7.18555 4.08203 7.05963 4.08203 6.9043C4.08203 6.74897 3.95611 6.62305 3.80078 6.62305C3.64545 6.62305 3.51953 6.74897 3.51953 6.9043C3.51953 7.05963 3.64545 7.18555 3.80078 7.18555Z"
                fill="#AAB6EC"
            />
            <path d="M1.84375 2.53906H1.11719V2.89062H1.84375V2.53906Z" fill="#AAB6EC" />
            <path
                d="M4.56543 5.35156C5.05084 5.35156 5.44434 4.95806 5.44434 4.47266C5.44434 3.98725 5.05084 3.59375 4.56543 3.59375C4.08002 3.59375 3.68652 3.98725 3.68652 4.47266C3.68652 4.95806 4.08002 5.35156 4.56543 5.35156Z"
                fill="#AAB6EC"
            />
            <path d="M5.06348 4.55469H4.4834V3.82812H4.64746V4.39062H5.06348V4.55469Z" fill="#EDEFF1" />
            <path
                d="M5.43163 4.11398C5.33585 3.88269 5.15569 3.70253 4.92439 3.60672L4.87955 3.71499C5.08195 3.79882 5.23956 3.95644 5.32338 4.15882C5.4072 4.3612 5.4072 4.5841 5.32338 4.78648C5.23955 4.98887 5.08192 5.14648 4.87954 5.23031C4.67717 5.31413 4.45427 5.31413 4.25187 5.23031C4.04949 5.14648 3.89187 4.98885 3.80805 4.78648C3.72422 4.58411 3.72422 4.3612 3.80805 4.15882C3.87436 3.99871 3.98699 3.86681 4.13129 3.7771L4.09445 3.87493L4.20413 3.91621L4.31603 3.61896L4.01207 3.52681L3.97809 3.63896L4.08111 3.67019C3.91041 3.77279 3.7774 3.92656 3.69978 4.11396C3.60398 4.34525 3.60398 4.60001 3.69979 4.83132C3.79559 5.06261 3.97573 5.24275 4.20702 5.33857C4.32269 5.38647 4.44418 5.41043 4.5657 5.41043C4.6872 5.41043 4.80874 5.38647 4.92436 5.33858C5.15567 5.24276 5.33581 5.06262 5.43162 4.83132C5.52743 4.60004 5.52744 4.34527 5.43163 4.11398Z"
                fill="#EDEFF1"
            />
        </g>
        <defs>
            <clipPath id="clip0_0_1PreOrder">
                <rect width="6" height="6" fill="white" transform="translate(1 2)" />
            </clipPath>
        </defs>
    </svg>
</template>
